import { FC } from 'react';
import './games.css';

interface Props {
    tiers: string[];
    tier: string;
    setTier: (tier: string) => void;
}

export const RouletteTiersComponent: FC<Props> = ({ tiers, tier, setTier }) => {
    return (
        <>
            <div className='bet-cta'>on</div>
            <div className='horizontal-center gap-8'>
                {tiers.map((item) => (
                    <button
                        key={item}
                        onClick={() => setTier(item)}
                        className={tier === item ? 'bet-item-selected' : 'bet-item'}
                    >
                        {item}
                    </button>
                ))}
            </div>
        </>
    );
};
